<div class="file-input-wrapper">
    <input 
      type="file" 
      #fileInput
      accept=".csv"
      (change)="onFileSelected($event)"
      class="file-input">
    <label for="file-input" class="file-label">
      Choose CSV File
    </label>
  </div>
  @if (this.csvFile != null){
<button (click)="upload()">
  Upload File
</button>
  }
